import gql from 'graphql-tag';

export default gql`
  query taLoginPageTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          travelAgentLoginPage {
            taTitleLabel
            taIATALabel
            taIATAPlaceholderLabel
            taPasswordLabel
            taPasswordPlaceholderLabel
            taAgencyNameLabel
            taAgencyNamePlaceholderLabel
            taPartneringLabel
            taBookingEarnContent
            taBookingEarnList
            taloginLoginButtonLabel
            taEnrollButtonLabel
            taForgotPasswordContentLabel
            taLogOutLabel
            taIataNumberLabel
            taIataNumberDescription
          }
          common {
            forgotPasswordTitle
          }
          loginSignUpForm {
            loginSignupRememberMe
          }
          travelAgentEnrollmentPage {
            taEnrollmentTitleLabel
            taEnrollmentAllAgenciesLabel
            taEnrollmentAllAgenciesContent
            taEnrollmentForeignAgenciesLabel
            taEnrollmentForeignAgenciesContent
            taEnrollmentAmericanAgenciesLabel
            taEnrollmentAmericanAgenciesContent
            taFormContentLabel
            taAgencyNameLabel
            taAgencyAddressLabel
            taSelectCountryLabel
            taSelectStateLabel
            taPhoneNumberLabel
            taFaxNumberLabel
            taEmailAddressLabel
            taContactNameLabel
            taIdentificationNumberLabel
            taRadioTrueOption
            taRadioArcOption
            taRadioCliaOption
            taRadioIataOption
            taRadioNumberContent
            taCreateAgencyPasswordLabel
            taCreateAgencyPasswordContent
            taAgencyCertificateLabel
            taW9orW8BenLabel
            taCorporateOfficeContent
            taSubmitButtonLabel
            taCancelButtonLabel
            taSelectCountryDefaultValueLabel
            taSelectStatePlaceHolderLabel
            taAgencyAddressPlaceHolderLabel
            taCityPlaceHolderLabel
            taPincodePlaceHolderLabel
            taSelectCountryPlaceHolderLabel
            moreInfoLabel
            lessInfoLabel
            taEnrollmentSuccessfulMessage
          }
          travelAgentErrorMessage {
            iataRequiredMessage
            passwordRequiredMessage
            passwordMinLengthMessage
            incorrectLoginMessage
            unknownLoginErrorMessage
            agentNameRequiredMessage
            agencyNameRequiredMessage
            agencyAddressRequiredMessage
            selectCountryRequiredMessage
            selectStateRequiredMessage
            phoneNumberRequiredMessage
            faxNumberRequiredMessage
            emailAddressRequiredMessage
            contactNameRequiredMessage
            agencyIdentificationRequiredMessage
            passwordCreationRequiredMessage
            agencyCertRequiredMessage
            w9CertRequiredMessage
            agencyCityRequiredMessage
            agencyPincodeRequiredMessage
            agencyInvalidPhoneNumberErrorMessage
            agencyInvalidFaxNumberErrorMessage
            agencyInvalidEmailErrorMessage
            agencyInvalidPasswordErrorMessage
            agencyMinPasswordErrorMessage
            agencyMaxPasswordErrorMessage
            agencyFileUploadLimitMessage
          }
        }
      }
    }
  }
`;
